export interface ICreatePrescriptionUrlModel {
  patientID: string;
  patientCaseID: string;
  doctorID: string;
}

export class CreatePrescriptionUrlModel {
  constructor(data?: ICreatePrescriptionUrlModel) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          ( this as any)[property] = (data as any)[property];
        }
      }
    }
  }
}
